/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Profile_Hero_Refreshprofile1Inputs */

const id_profile_hero_refreshprofile1 = /** @type {(inputs: Profile_Hero_Refreshprofile1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Segarkan profil`)
};

const ms_profile_hero_refreshprofile1 = /** @type {(inputs: Profile_Hero_Refreshprofile1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Segarkan profil`)
};

const da_profile_hero_refreshprofile1 = /** @type {(inputs: Profile_Hero_Refreshprofile1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Opdater profil`)
};

const de_profile_hero_refreshprofile1 = /** @type {(inputs: Profile_Hero_Refreshprofile1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Profil aktualisieren`)
};

const en_us2_profile_hero_refreshprofile1 = /** @type {(inputs: Profile_Hero_Refreshprofile1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Refresh profile`)
};

const es_es2_profile_hero_refreshprofile1 = /** @type {(inputs: Profile_Hero_Refreshprofile1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Actualizar perfil`)
};

const es_mx2_profile_hero_refreshprofile1 = /** @type {(inputs: Profile_Hero_Refreshprofile1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Actualizar perfil`)
};

const fil_profile_hero_refreshprofile1 = /** @type {(inputs: Profile_Hero_Refreshprofile1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`I-refresh ang profile`)
};

const fr_profile_hero_refreshprofile1 = /** @type {(inputs: Profile_Hero_Refreshprofile1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Actualiser le profil`)
};

const it_profile_hero_refreshprofile1 = /** @type {(inputs: Profile_Hero_Refreshprofile1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aggiorna profilo`)
};

const hu_profile_hero_refreshprofile1 = /** @type {(inputs: Profile_Hero_Refreshprofile1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Profil frissítése`)
};

const nl_profile_hero_refreshprofile1 = /** @type {(inputs: Profile_Hero_Refreshprofile1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Profiel vernieuwen`)
};

const no_profile_hero_refreshprofile1 = /** @type {(inputs: Profile_Hero_Refreshprofile1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Oppdater profil`)
};

const pl_profile_hero_refreshprofile1 = /** @type {(inputs: Profile_Hero_Refreshprofile1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Odśwież profil`)
};

const pt_br2_profile_hero_refreshprofile1 = /** @type {(inputs: Profile_Hero_Refreshprofile1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Atualizar perfil`)
};

const pt_profile_hero_refreshprofile1 = /** @type {(inputs: Profile_Hero_Refreshprofile1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Atualizar perfil`)
};

const ro_profile_hero_refreshprofile1 = /** @type {(inputs: Profile_Hero_Refreshprofile1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Reîmprospătează profilul`)
};

const fi_profile_hero_refreshprofile1 = /** @type {(inputs: Profile_Hero_Refreshprofile1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Päivitä profiili`)
};

const sv_profile_hero_refreshprofile1 = /** @type {(inputs: Profile_Hero_Refreshprofile1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Uppdatera profil`)
};

const vi_profile_hero_refreshprofile1 = /** @type {(inputs: Profile_Hero_Refreshprofile1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Làm mới hồ sơ`)
};

const tr_profile_hero_refreshprofile1 = /** @type {(inputs: Profile_Hero_Refreshprofile1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Profili yenile`)
};

const cs_profile_hero_refreshprofile1 = /** @type {(inputs: Profile_Hero_Refreshprofile1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Obnovit profil`)
};

const bg_profile_hero_refreshprofile1 = /** @type {(inputs: Profile_Hero_Refreshprofile1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Опресняване на профила`)
};

const ru_profile_hero_refreshprofile1 = /** @type {(inputs: Profile_Hero_Refreshprofile1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Обновить профиль`)
};

const uk_profile_hero_refreshprofile1 = /** @type {(inputs: Profile_Hero_Refreshprofile1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Оновити профіль`)
};

const ar_profile_hero_refreshprofile1 = /** @type {(inputs: Profile_Hero_Refreshprofile1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`تحديث الملف الشخصي`)
};

const hi_profile_hero_refreshprofile1 = /** @type {(inputs: Profile_Hero_Refreshprofile1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`प्रोफ़ाइल रिफ्रेश करें`)
};

const th_profile_hero_refreshprofile1 = /** @type {(inputs: Profile_Hero_Refreshprofile1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`รีเฟรชโปรไฟล์`)
};

const ja_profile_hero_refreshprofile1 = /** @type {(inputs: Profile_Hero_Refreshprofile1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`プロフィールを更新`)
};

const zh_cn2_profile_hero_refreshprofile1 = /** @type {(inputs: Profile_Hero_Refreshprofile1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`刷新个人资料`)
};

const zh_hant1_profile_hero_refreshprofile1 = /** @type {(inputs: Profile_Hero_Refreshprofile1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`重新整理個人資料`)
};

const ko_profile_hero_refreshprofile1 = /** @type {(inputs: Profile_Hero_Refreshprofile1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`프로필 새로고침`)
};

/**
* | output |
* | --- |
* | "Refresh profile" |
*
* @param {Profile_Hero_Refreshprofile1Inputs} inputs
* @param {{ locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
const profile_hero_refreshprofile1 = /** @type {((inputs?: Profile_Hero_Refreshprofile1Inputs, options?: { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Profile_Hero_Refreshprofile1Inputs, { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_profile_hero_refreshprofile1(inputs)
	if (locale === "ms") return ms_profile_hero_refreshprofile1(inputs)
	if (locale === "da") return da_profile_hero_refreshprofile1(inputs)
	if (locale === "de") return de_profile_hero_refreshprofile1(inputs)
	if (locale === "en-US") return en_us2_profile_hero_refreshprofile1(inputs)
	if (locale === "es-ES") return es_es2_profile_hero_refreshprofile1(inputs)
	if (locale === "es-MX") return es_mx2_profile_hero_refreshprofile1(inputs)
	if (locale === "fil") return fil_profile_hero_refreshprofile1(inputs)
	if (locale === "fr") return fr_profile_hero_refreshprofile1(inputs)
	if (locale === "it") return it_profile_hero_refreshprofile1(inputs)
	if (locale === "hu") return hu_profile_hero_refreshprofile1(inputs)
	if (locale === "nl") return nl_profile_hero_refreshprofile1(inputs)
	if (locale === "no") return no_profile_hero_refreshprofile1(inputs)
	if (locale === "pl") return pl_profile_hero_refreshprofile1(inputs)
	if (locale === "pt-BR") return pt_br2_profile_hero_refreshprofile1(inputs)
	if (locale === "pt") return pt_profile_hero_refreshprofile1(inputs)
	if (locale === "ro") return ro_profile_hero_refreshprofile1(inputs)
	if (locale === "fi") return fi_profile_hero_refreshprofile1(inputs)
	if (locale === "sv") return sv_profile_hero_refreshprofile1(inputs)
	if (locale === "vi") return vi_profile_hero_refreshprofile1(inputs)
	if (locale === "tr") return tr_profile_hero_refreshprofile1(inputs)
	if (locale === "cs") return cs_profile_hero_refreshprofile1(inputs)
	if (locale === "bg") return bg_profile_hero_refreshprofile1(inputs)
	if (locale === "ru") return ru_profile_hero_refreshprofile1(inputs)
	if (locale === "uk") return uk_profile_hero_refreshprofile1(inputs)
	if (locale === "ar") return ar_profile_hero_refreshprofile1(inputs)
	if (locale === "hi") return hi_profile_hero_refreshprofile1(inputs)
	if (locale === "th") return th_profile_hero_refreshprofile1(inputs)
	if (locale === "ja") return ja_profile_hero_refreshprofile1(inputs)
	if (locale === "zh-CN") return zh_cn2_profile_hero_refreshprofile1(inputs)
	if (locale === "zh-Hant") return zh_hant1_profile_hero_refreshprofile1(inputs)
	return ko_profile_hero_refreshprofile1(inputs)
});
export { profile_hero_refreshprofile1 as "profile.hero.refreshProfile" }